import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserSessionService } from "../../../app-user-session.service";
import { NameComponent } from "../../../blocks/names";
import { OutPatReservationService } from "../../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service";
import { SmsService } from "../../../promotions/SmsService/Sms.service";
import { IPromotionsMsgLog } from "../../../promotions/promotions";
import { FormSettingsService, SharedDateService, PatientParms } from "../../../shared";
import { CallData, MsgTemplate, TotalData } from "../../call-center-reservation";
import { Patient, PatientData, PatientVM } from "../../../registeration/patients";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { MedicalRepositoryService } from "../../../medical-recored/medical-repository.service";
import { ToastService } from "../../../blocks";
import { SimilarPatientsDataComponent } from "../../../registeration/similar-patients-data/similar-patients-data.component";
import { NameService } from "../../../blocks/names/name.service";


@Component({
  selector: 'app-simple-call-center-patient-reservation',
  templateUrl: './simple-call-center-patient-reservation.component.html',
  styleUrls: ['./simple-call-center-patient-reservation.component.css']
})
export class SimpleCallCenterPatientReservationComponent implements OnInit, OnDestroy {
  @ViewChild('name') nameComponent: NameComponent;
  patReservationForm: UntypedFormGroup;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  mobileCountry = require("setting/country_1.json");
  private jsonUrl: string = 'setting/country_1.json';
  patReservationParams: any = {};
  templateMsg: string = '';
  msgTemplate: MsgTemplate = <MsgTemplate>{};
  hideSendMessageBox: any;
  isEmergency = false;
  callCenterPatientReservationTypeFlag: number = 0; // مريض ثابت او كول سنتر من الكول سنتر
  outPatientPatientReservationTypeFlag: number = 0; // مريض ثابت او كول سنتر من  العيادات الخارجية
  callDataSerial: number
  messagesLog: IPromotionsMsgLog = <IPromotionsMsgLog>{};
  msgTemplateData: any
  sendMessageFlag: number = 1;
  exisitedPatFalg: boolean = false;
  countries: any[] = [];
  mark_Leads: any = {};
  callData: CallData = <CallData>{};
  patientParms: PatientParms[];
  patnum: number = 1;
  callMainDataArr = [];
  showNewPatientArea: boolean = false;
  matrixData: any;
  patCode: number
  cCCallBeneficiarySerial: number
  branchId: number = 0;
  serviceCode: any;
  reservationType: number = 2
  phoneNumber: any;
  constructor(private _fb: UntypedFormBuilder,
    private _formServiceSettings: FormSettingsService,
    private _sharedDateService: SharedDateService,
    private _callCenterReservationService: OutPatReservationService,
    private _SmsService: SmsService,
    private _router: Router,
    private _USS: UserSessionService,
    private _medicalRepo: MedicalRepositoryService,
    public translate: TranslateService,
    private _toaster: ToastService,
    private _namesService: NameService,


  ) { }

  ngOnInit() {
    // this.patReservationForm.reset()
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log("currentUser = ", currentUser);
    this.branchId = +currentUser.branchId ? +currentUser.branchId : 0;
    this.isEmergency = this._router.url.includes('emergency');
    this.getModuleSettings();
    if (this._USS.getSessionKey('MatrixSessionData')) {
      this.matrixData = this._USS.getSessionKey<any>('MatrixSessionData');
      this._USS.subscribeToKey$('MatrixSessionData').pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
          if (keys && keys.value) {
            this.matrixData = keys.value;
          }
        });
      this.matrixData.reservationDate = this.matrixData.startTimeSlot;
      console.log('_____________ this.matrixData = ', this.matrixData);
      console.log(" this.matrixData.reservationFrom = ", this.matrixData.reservationFrom);
    }
    this.initlizeControls();

    this.resetForm()
  }
  addNewPat() {
    this.showNewPatientArea = true;
    this.patCode = null;
    this.cCCallBeneficiarySerial = null;
  }

  ngAfterViewInit() {
    let setDefaults = true;

    if (!this.isEmergency) {
      this._formServiceSettings.setFormSettings(
        this.patReservationForm as UntypedFormGroup,
        'patient',
        this.callData,
        setDefaults,
        'setting'
      );
      this.checkcountryCode();
    }
    if (this.isEmergency) {
      this._formServiceSettings.setFormSettings(
        this.patReservationForm as UntypedFormGroup,
        'emergency',
        this.callData,
        setDefaults, 'setting'
      );
    }
  }
  getJsonDataFile() {
    this._medicalRepo.readJsonFile(this.jsonUrl)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) {
          this.countries = res.countries


        }
      });

  }

  checkcountryCode() {
    if (this.patReservationForm.contains('address.countryCode'))
      console.log(this.patReservationForm)
    this.patReservationForm.get('mobile').clearValidators();
    this.patReservationForm.get('nationalityId')
      .valueChanges
      .subscribe(selectedValue => {
        if (selectedValue) {
          this.countries.forEach(el => {
            if (el.code == selectedValue) {
              if (el.regex && el.regex.length > 0) {
                this.patReservationForm.get('mobile').setValidators([
                  Validators.pattern(new RegExp(el.regex ? el.regex : ''))
                ]);

                this.patReservationForm.get('familyMobile').setValidators([
                  Validators.pattern(new RegExp(el.regex ? el.regex : ''))
                ]);
              } else {
                this.patReservationForm.get('mobile').clearValidators();
                this.patReservationForm.get('mobile').updateValueAndValidity();
                this.patReservationForm.get('familyMobile').clearValidators();
                this.patReservationForm.get('familyMobile').updateValueAndValidity();
              }
              this.patReservationForm.get('mobile').updateValueAndValidity();
              this.patReservationForm.get('familyMobile').updateValueAndValidity();
            }
          });
        }


      });
  }
  cancelAddNewPat() {
    this.showNewPatientArea = false;
  }
  initlizeControls() {
    this.patReservationForm = this._fb.group({
      code: 0,
      dateHijri: new Date(),
      customCode: [''],
      oldCode: '',
      fname: '',
      sname: '',
      tname: '',
      lname: '',
      titleCode: '',
      name: this._fb.group({}),
      therapeuticCards: this._fb.group({}),
      address: this._fb.group({}),
      identity: this._fb.group({}),
      gender: null,
      birthDateNgb: null,
      birthPlace: [''],
      homePhone: '',
      mailAddress: [''],
      mobile2: [''],
      fatherName: '',
      motherName: '',
      nickName: '',
      parentId: '',
      employeeId: '',
      fileNo: '',
      religionId: [''],
      maritalStatus: [''],
      bloodGroup: '',
      rhValue: '',
      stopFlag: '',
      vipFlag: '',
      mortaliyFlag: '',
      mortalityDate: '',
      vipLevel: '',
      dateHijriNgb: null,
      mortalityDateNgb: null,
      placeCode: '',
      startDateNgb: '',
      ngbDayStartHoure: '',
      reservationDate: this.matrixData.startTimeSlot,
      callerName: '',
      callerPhone: '',
      callerAddress: '',
      nationalityId: '',
      callNotes: [''],
      callSort: [''],
      callReason: 3,
      callResult: [''],
      specialization: [''],
      howToReachUs: null,
      branchAddress: null,
      reservationType: 2,
      callmethod: 1,
      serviceCode: '',
      serviceName: '',
      visitSerial: '',
      approxAge: '',
      patCode: '',
      patientServiceLevelOne: '',
      patientServiceLevelTwo: '',
      patientServiceLevelThree: '',
      expectedDate: this.matrixData.startTimeSlot,
      doctorID: this.matrixData.resourceId,
      cost: '',
      ageInYear: null,
      ageInMonth: null,
      ageInDays: null,
      leadType: 1,
      clientCode: '',
      docId: this.matrixData.resourceId,
      anesthesiologist: '',
      clinicCode: '',
      serial: 0,
      previousPatient: '',
      customerId: '',
      secoundMobile: '',
      device: '',
      mobile: ['', Validators.compose([
        Validators.required,
        Validators.pattern(new RegExp(this.mobileCountry.countries[0].regex))

      ])],
      familyMobile: ['', Validators.compose([
        Validators.required,
        Validators.pattern(new RegExp(this.mobileCountry.countries[0].regex))

      ])]

    });

  }




  // onMobileKeyUp() {
  //   let jsonEmpFormSetup
  //   let mobValue
  //   mobValue = this.patReservationForm.get('mobile').value
  //   jsonEmpFormSetup = this._formServiceSettings.getFormJsonObj()
  //   this.patReservationForm.get('mobile').setValue(mobValue)

  // }

  setMobAlert: boolean
  onMobileKeyUp() {
    let jsonEmpFormSetup
    let mobValue
    mobValue = this.patReservationForm.get('mobile').value
    console.log('MobValue', mobValue)
    jsonEmpFormSetup = this._formServiceSettings.getFormJsonObj()
    console.log('jsonEmpFormSetup', jsonEmpFormSetup)
    console.log('MobileLength', this.patReservationForm.get('mobile').value
    )
    if (jsonEmpFormSetup['mobile']['max_length'] < ((this.patReservationForm.get('mobile').value).length)
      || jsonEmpFormSetup['mobile']['min_length'] > ((this.patReservationForm.get('mobile').value).length)
    ) {
      this.setMobAlert = true
      this.patReservationForm.get('mobile').setValue(null)
    }
    else {
      this.setMobAlert = false
      this.patReservationForm.get('mobile').setValue(mobValue)
    }
    this.searchSimilarDate(mobValue, 'mobile');
  }
  similarData: any = [];
  searchSimilarDate(value: any, type: any) {
    this.similarData = []
    let val: Patient = <PatientVM>{};
    if (type == 'names') {
      val.fullnameAr = value;
    }
    else if (type == 'mobile') {
      val.mobile = value
    }
    if (val) {
      this._namesService.findSimilarName(val).subscribe(
        searchResult => {
          if (searchResult.data && searchResult.data.length > 0) {
            this.similarData = searchResult.data;
            if (this.similarData.length > 0) {
              this.getSimilarData(value, type);
            }
          }

        }, error => console.log(error),
        () => {
        });
    }
  }
  dynamicComponent: any;
  @ViewChild('popup') content: any;

  getSimilarData(value: any, type: any) {
    let similarObj: any = {};
    similarObj.value = value;
    similarObj.type = type;
    this.dynamicComponent = SimilarPatientsDataComponent;
    this._USS.setSessionKey('findSimilarBy', this.similarData)
    this.content.openModal("SimilarPatientsDataComponent", "SimilarPatientsData", { findSimilarBy: this.similarData });
  }
  //End Of Features Area
  onFamilyMobileKeyUp() {
    let jsonEmpFormSetup
    let familyMobile
    familyMobile = this.patReservationForm.get('familyMobile').value
    console.log('familyMobile', familyMobile)
    jsonEmpFormSetup = this._formServiceSettings.getFormJsonObj()
    console.log('jsonEmpFormSetup', jsonEmpFormSetup)
    console.log('familyMobileLength', this.patReservationForm.get('familyMobile').value
    )
    if (jsonEmpFormSetup['familyMobile']['max_length'] < ((this.patReservationForm.get('familyMobile').value).length)
      || jsonEmpFormSetup['familyMobile']['min_length'] > ((this.patReservationForm.get('familyMobile').value).length)
    ) {
      +

        this.patReservationForm.get('familyMobile').setValue(null)
    }
    else {
      this.patReservationForm.get('familyMobile').setValue(familyMobile)
    }
  }
  getCallData() {
    this.callData.serial = -1
    this.callData.anesthesiologist = null;
    this.callData.serviceCode = this.serviceCode;
    this.callData.callTypeFalg = 1
    // ------------------------------------------------------------
    this.callData.cCCallBeneficiarySerial = this.cCCallBeneficiarySerial;
    this.callData.patCode = this.patCode;
    this.callData.branchId = this.branchId;
    // ------------------------------------------------------
    this.callData.callTypeFalg = 1
    this.callData.specialization = this.matrixData.speciality;
    this.callData.clinicCode = null;
    this.callData.expectedStartTime = this.matrixData.startTimeSlot;
    this.callData.expectedEndTime = this.matrixData.endTimeSlot;
    this.callData.minutesPerSlot = this.matrixData.minutesPerSlot;
    this.callData.address = null;
    this.callData.callerName = this.patReservationForm.value.callerName;
    this.callData.phoneNumber = this.patReservationForm.value.callerPhone ? this.patReservationForm.value.callerPhone : this.patReservationForm.value.mobile;
    this.callData.familyPhoneNumber = this.patReservationForm.value.familyMobile

    this.callData.secoundMobile = null;
    this.callData.notes = null;
    this.callData.callSort = 1;
    this.callData.callReason = 3;
    this.callData.callResult = null;
    this.callData.reservationType = 1;
    this.callData.callmethod = 1;
    this.callData.reservationDate = this.matrixData.startTimeSlot;
    this.callData.device = null;
    this.callData.docId = this.matrixData.resourceId

    if (this.matrixData.reservationFrom == 1) {
      this.callData.bookedByFlag = 3;  // from out patient
    }
    else
      if (this.matrixData.reservationFrom == 2) {
        this.callData.bookedByFlag = 1; // call center
      }

  }



  getPatientFromForm(): any {
    let dummy = <any>(this.patReservationForm.value);
    let formValue = Object.assign({}, dummy);
    formValue.code = formValue.code ? formValue.code : 0;
    formValue.titleCode = this.nameComponent.nameForm.get('titleCode').value;
    formValue.fnameAr = this.nameComponent.nameForm.get('fnameAr').value;
    formValue.fnameEn = this.nameComponent.nameForm.get('fnameEn').value;
    formValue.snameAr = this.nameComponent.nameForm.get('snameAr').value;
    formValue.snameEn = this.nameComponent.nameForm.get('snameEn').value;
    formValue.tnameAr = this.nameComponent.nameForm.get('tnameAr').value;
    formValue.tnameEn = this.nameComponent.nameForm.get('tnameEn').value;
    formValue.lnameAr = this.nameComponent.nameForm.get('lnameAr').value;
    formValue.lnameEn = this.nameComponent.nameForm.get('lnameEn').value;
    formValue.fullnameAr = formValue.fnameAr + ' ' + formValue.snameAr + ' ' + formValue.tnameAr + ' ' + formValue.lnameAr;
    formValue.fullnameEn = formValue.fullnameAr;
    this.callData.callerName = formValue.fullnameAr;
    formValue.mobile = formValue.mobile;
    formValue.familyMobile = formValue.familyMobile;
    formValue.patExpectedFlag = 0
    formValue.expectedDate = this._sharedDateService.convertFromNgBsToDate(formValue.expectedDate)
    formValue.birthDate = this._sharedDateService.convertFromNgBsToDate(this.patReservationForm.get('birthDateNgb').value);

    console.log('***********formValue*****formValue', formValue)
    return formValue;
  }


  calcage(e: any) {
    let dob_date = new Date()
    let f = (dob_date.getFullYear() - e.year);
    this.patReservationForm.get('approxAge').setValue(f);
  }

  /////////////////////get higri date #ibrahim from gregorian date
  getHigriDate() {
    this.callData.birthDateNgb = this._sharedDateService.convertFromNgBsToDate(
      this.patReservationForm.get('birthDateNgb').value
    )
  }

  clacBirthDateFromAge(_year: number, _month: number, _days: number) {

    let _birthDate = this._sharedDateService.dateFromAge(
      +_year, +_month, +_days
    );
    let DOB = this._sharedDateService.convertFromDateToNgBsObject(
      _birthDate
    );
    _birthDate
    this.patReservationForm.patchValue({
      birthDateNgb: DOB
    });

    this.getHigriDate();
  }

  ngOnDestroy() {
    this.patReservationForm.reset()

  }
  resetForm() {
    if (this.patReservationForm) {
      this.patReservationForm.reset();
    }
    if (this.nameComponent) {
      this.nameComponent.nameForm.reset();
    }
    if (this._USS.getSessionKey('MatrixSessionData')) {
      this._USS.removeSessionKey('MatrixSessionData');
    }


  }

  patientClicked(e: any) {
    if (e && e.code > 0) {
      this.patCode = e.code;
      this.phoneNumber = e.mobile
      this.cCCallBeneficiarySerial = null;
    }
  }
  clientClicked(e: any) {
    if (e && e.code > 0) {
      this.cCCallBeneficiarySerial = e.code;
      this.phoneNumber = e.mobile
      this.patCode = null;
    }
  }
  branchClicked(e: any) {
    if (e && e.code > 0) {
      this.branchId = e.code;
    }
  }
  onServicsClicked(e: any) {
    if (e && e.code > 0) {
      this.serviceCode = e.code;
    }
  }
  savePatientReservation() {
    if (this.cCCallBeneficiarySerial == null && this.patCode == null) {
      if (!this.patReservationForm.get('mobile').value && !this.patReservationForm.get('familyMobile').value) {
        this._toaster.activateMsg('UI600');
        return
      }
      if (!this.nameComponent.nameForm.get('fnameAr').value == null || !this.nameComponent.nameForm.get('snameAr').value) {
        this._toaster.activateMsg('FULLNAME');
        return
      }
    }

    if (this.reservationType == 1

    ) {
      for (var i = 0; i < this.patnum; i++) {
        this.callMainDataArr[i] = this.getPatientFromForm();
        this.callMainDataArr[i].branchId = this.branchId;
      }
      console.log("Reserved As Constant patient");
      let patientDetails = <PatientData>{
        patient: this.callMainDataArr[0],
        familyDetail: null,
        therapeuticCards: null,
        docManagementData: null,
        patients: this.callMainDataArr,
        emrPatHistory: null

      };
      this._callCenterReservationService.addPatient(patientDetails)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            if (c.data && c.data.length > 0) {
              if (c.data[0].code) {
                c.data[0]['patCode'] = c.data[0].code;
                this._USS.setSessionKey('SimpleCallCenterPatientReservation', c.data[0]);
                this.patCode = c.data[0].serial ? c.data[0].serial : c.data[0].code

                if (this.sendMessageFlag == 1) {
                  this.getMsgTemplate()
                }
              }
            }
            this.resetForm();
          }
        },
          err => console.log(err),
          () => {
            this._USS.closeModalKey('SimpleCallCenterPatientReservationComponent', 'Cross click')

          });
      console.log("patientDetails = ", patientDetails);

    }
    else if (this.reservationType == 2) {
      console.log("Reserved Call Center Patient")
      this.getCallData();
      // حجز لمريض او عميل موجود بالفعل
      if (this.callData.patCode > 0 || this.callData.cCCallBeneficiarySerial > 0) {
        this.callMainDataArr = [];
      }
      else {
        for (var i = 0; i < this.patnum; i++) {
          this.callMainDataArr[i] = this.getPatientFromForm();
          this.callMainDataArr[i].branchId = this.branchId;
        }
      }
      if (!this.callData.phoneNumber) {
        this.callData.phoneNumber = this.phoneNumber ? this.phoneNumber : this.patReservationForm.value.familyMobile;
      }
      this.mark_Leads.doctorID = this.matrixData.resourceId;
      this.mark_Leads.leadType = 1
      this.mark_Leads.expectedDate = new Date();
      this.mark_Leads.discountType = 0;
      let patientdata = <TotalData>{
        callMainData: this.callMainDataArr,
        therapeuticCards: null,
        callData: this.callData ? this.callData : null,
        mark_Leads: this.mark_Leads
      };
      this._callCenterReservationService.addCallerData(patientdata)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            if (c.data && c.data.length > 0) {
              this.callDataSerial = c.data[0].serial ? c.data[0].serial : c.data[0].code
              if (this.sendMessageFlag == 1) {
                this.getMsgTemplate();
              }
            }
            this.resetForm();
          }
        },
          err => console.log(err),
          () => {
            this._USS.closeModalKey('SimpleCallCenterPatientReservationComponent', 'Cross click')

          });
      console.log("patientdata = ", patientdata);

    } else {
      this._toaster.activateMsg('قم بتحديد نوع الحجز مريض ام عميل');
    }
  }


  //data of sms message
  saveMessagesLog() {
    //get template message
    if (this.msgTemplateData) {
      if (this.msgTemplateData.smsTemplate) {
        //create message
        this.replacrDatainSms()
        this.messagesLog.serial = -1
        this.messagesLog.patCode = this.exisitedPatFalg ? this.callData.patCode : null;
        this.messagesLog.message = this.msgTemplateData.smsTemplate
        this.messagesLog.sentDate = new Date()
        this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
        this.messagesLog.mobile = this.patReservationForm.value.callerPhone ? this.patReservationForm.value.callerPhone : this.patReservationForm.value.mobile;;
        if (!this.messagesLog.mobile) {
          this.messagesLog.mobile = +this.callData.phoneNumber;
        }
        this.messagesLog.callDataSerial = this.callDataSerial
        this.messagesLog.messageType = 3 //رساله تاكيد حجز مريض
        this._SmsService.RemindingBookingMsg([this.messagesLog])
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            if (res && res.returnFlag) {

            }
          })


      }
    }
  }

  replacrDatainSms() {
    //let SmsData:any
    let SmsData = <any>{
      reservationDate: this.matrixData.startTimeSlot,
      doctorName: this.matrixData.doctorName,
      shortDoctorName: this.matrixData.shortDoctorName
    };
    this.msgTemplateData.smsTemplate = this._SmsService.replaceSmSMsgData(SmsData, this.templateMsg)
    console.log(this.msgTemplateData.smsTemplate)

  }

  getModuleSettings() {
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 10123 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.sendMessageFlag = +c.data[0]['sendMsgFlag'] == 1 ? 1 : 0;
        }
      });
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 5410 }) // Call Center Module
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.callCenterPatientReservationTypeFlag = +c.data[0]['registCallerasPatient']; // call center  مريض طبي ثابت ولا كول سنتر
          this.outPatientPatientReservationTypeFlag = +c.data[0]['registCallerasOutPatient']; // out patient مريض طبي ثابت ولا كول سنتر
          console.log("this.callCenterPatientReservationTypeFlag = ", this.callCenterPatientReservationTypeFlag);
          console.log("this.outPatientPatientReservationTypeFlag = ", this.outPatientPatientReservationTypeFlag);
        }
      });
  }

  getMsgTemplate() {
    this.msgTemplate.fieldName = 'reservationPatientSMS'
    this.msgTemplate.reservationDate = this._sharedDateService.convertFromNgBsToDate(this.matrixData.startTimeSlot);
    this.msgTemplate.specialityId = this.matrixData.speciality;
    this.msgTemplate.empId = this.matrixData.resourceId
    this._SmsService.getMsgTemplate(this.msgTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.msgTemplateData = res.data[0];
            this.templateMsg = this.msgTemplateData.smsTemplate
            this.hideSendMessageBox = this.msgTemplateData.sendSmsFlag
            if (this.msgTemplateData.code > 0) {
              this.saveMessagesLog();
            }
          }
        }
      )
  }
}
